import { Menu } from "antd";
import styled from "styled-components";

import color from "../_style/color";

export default styled(Menu).attrs((props) => ({ mode: props.mode }))`
  border: 1px solid ${color.gainsboro};
  border-left: 0;
  width: 100%;
  display: ${({ mode }) => (mode === "horizontal" ? "flex" : "block")};

  .ant-menu-item-selected,
  .ant-menu-item-selected:hover {
    color: ${color.primary} !important;
    background: ${color.whisper};
  }

  .ant-menu-item {
    width: 100%;
    display: block;
    padding: 0;
    border-left: 1px solid ${color.gainsboro};
    border-bottom: 1px solid ${color.gainsboro};
    transition: unset;
  }

  .ant-menu-item:hover {
    color: unset;
    border-bottom: 1px solid ${color.gainsboro};
  }
`;
